import React, { useState } from "react";

const Design = ({ size, chairs, chairSize, borderColor = "#4186c2" }) => {
  // State to track if the table is selected
  const [isSelected, setIsSelected] = useState(false);

  // Function to toggle the selection
  const handleSelect = () => {
    setIsSelected((prev) => !prev);
  };

  const chairElements = Array.from({ length: chairs }, (_, index) => (
    <div
      key={index}
      className="chair"
      style={{
        transform: `rotate(${(360 / chairs) * index}deg) translate(${
          size / 2
        }px)`,
        width: `${chairSize}px`,
        height: `${chairSize}px`,
      }}
    >
      <div
        className="chair-circle"
        style={{
          width: `${chairSize}px`,
          height: `${chairSize}px`,
          border: `2px solid ${borderColor}`,
        }}
      ></div>
    </div>
  ));

  return (
    <div
      className={`inventory_table ${isSelected ? "selected" : ""}`}
      onClick={handleSelect}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        border: isSelected ? "2px solid #ff5733" : "2px solid transparent", // Highlight border color when selected
        cursor: "pointer", // Add a pointer cursor to indicate it's clickable
      }}
    >
      {chairElements}
    </div>
  );
};

export default Design;
